import { initReactI18next } from "react-i18next";
import i18n from "i18next";

import localeLt from "./locales/lt.json";
import localePl from "./locales/pl.json";
import { LANGUAGE } from "../constants/language";

const defaultLocale = LANGUAGE || "lt";
const language = i18n.language || defaultLocale;

export const defaultNS = "locale" + defaultLocale?.slice(-2, -1)?.toUpperCase() + defaultLocale?.slice(-1);
export const resources = {
  lt: {
    localeLt,
  },
  pl: {
    localePl,
  },
} as const;

i18n.use(initReactI18next).init({
  resources,
  lng: language,
  initImmediate: false,
  ns: ["localeLt", "localePl"],
  defaultNS,
  saveMissing: true,
  updateMissing: true,
  react: {
    useSuspense: true,
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
